import React, { Component } from 'react';
import HomePanel from '../HomePanel';
import {withRouter} from 'react-router-dom';
import { isUserLoggedIn } from '../../service/UserService';
import {Helmet} from "react-helmet";
import queryString from 'query-string';
import { getAllItems } from '../../service/ItemService';
import { renderToString } from 'react-dom/server';
import { gethelperImgSrc, getShieldImgSrc } from '../../util/Helper';

class ItemPage7 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: null
          }
    }
    
    componentDidMount() {
        this.loadItems();
    }

    loadItems = () =>{
        const { id } = queryString.parse(window.location.search);
        getAllItems().then(data => {
            //console.log("get termek:", data);
            if(id){
                this.setState({item: data.find(t=>t.id === id)}, ()=>{
                    console.log("found item:", this.state.item);
                });
            }
            
        });
    }

    register(id){
        if(isUserLoggedIn()){
            this.props.history.push("/termekregisztracio?termek="+id);
        }
        else{
            this.props.history.push("/regisztracio");
        }
    }

    render() { 
        let safeHTML = this.state.item?.pagecontent;
        if(safeHTML && safeHTML.indexOf("||fotoseged|") >=0){
            console.log("this.state.item?.id", this.state.item?.id);
            let shieldImgSrc = getShieldImgSrc(this.state.item?.id);
            let helperImgrc = gethelperImgSrc(this.state.item?.id);

            let insertjsx = (
                <div style={{marginTop:30}}>
                    <img alt="cimke" style={{display:'inline-block', width:'25%'}} src={shieldImgSrc}></img>
                    <img alt="kepseged" style={{display:'inline-block', width:'75%'}} src={helperImgrc}></img>
                </div>
            );

            safeHTML = safeHTML.replace("||fotoseged||", renderToString(insertjsx));
        }

        return ( 
            <div className="kwizda-itempage-container">
                <Helmet>
                    <meta 
                        name="title"
                        content="Cukkini Amazon kísérlet"
                    />
                    <meta name="description" content="Cukkini Amazon kísérlet" />
                    <meta name="keywords" content="nagy termés, kötődés, terméskötődés, termés növelés, biostimulátor, foszfor, bór, alga, paradicsom, biológiai, tesztelje ingyen, regisztráció, biológiai, biológiai gazdálkodás" />
                </Helmet>
                <div className="kwizda-itempage">
                    <div dangerouslySetInnerHTML={{ __html: safeHTML }} />
                    <br/>
                    <div className="kwizda-itempage-table-div">
                            <table className="kwizda-itempage-table">
                                <thead>
                                    <tr>
                                        <th>Nevezési határidő:</th>
                                        <th>Kísérlet megvalósítás időzítése: </th>
                                        <th>Megvalósítás helye: </th>
                                        <th>Helyszínek száma:</th>
                                        <th>Dokumentáció módja:</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{this.state.item?.deadline}</td>
                                        <td>{this.state.item?.proposed_time}</td>
                                        <td>{this.state.item?.agent}</td>
                                        <td>{this.state.item?.dose}</td>
                                        <td>{this.state.item?.type}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                </div>
                <br/>
                <HomePanel isItemPage={true} register={()=>this.register(this.state.item?.id)}></HomePanel>
            </div>
         );
    }
}

export default withRouter(ItemPage7);